import { DateTime } from 'luxon';

export type InvokeContextItem = {
  key: string;
  value: string;
};

export type InvokeContext = {
  values: InvokeContextItem[];
};

export enum ChatRoleEnum {
  ASSISTANT = 'assistant',
  DEVELOPER = 'developer',
  USER = 'user'
}

// must match strings from mas
export enum ChatMsgTypeEnum {
  STRUCTURED_CONTENT = 'StructuredContent',
  TEXTUAL_CONTENT = 'TextualContent',
  TYPING_ACTION = 'TypingAction'
}

export type AgentInvokeApiReqUser = {
  id: string;
  displayName: string;
  type: ChatRoleEnum;
};

export type CompletionReq = {
  clientId: string;
  context: InvokeContext;
  contexts?: Record<string, string>;
  correlationId?: string;
  inputs?: Record<string, string>;
  messages: ChatMsgReq[];
  agentId: string;
  requestId?: string;
  users: AgentInvokeApiReqUser[];
};

export type ChatMessageContentTextual = {
  type: ChatMsgTypeEnum.TEXTUAL_CONTENT;
  text: string;
};

export type ChatMessageContentStructured = {
  type: ChatMsgTypeEnum.STRUCTURED_CONTENT;
  data: Record<string, unknown>;
};

export type ChatMessageContentLowCode = {
  type: ChatMsgTypeEnum.STRUCTURED_CONTENT;
  data: {
    resp: string;
    debug?: string;
  }
};

export type ChatMessageContentTyping = {
  typing: boolean;
  type: ChatMsgTypeEnum.TYPING_ACTION;
};

/**
 * conversation will always be present
 * other keys depend on what's specified in a step's input and routes output section
 */
export type ChatMsgDebugIO = {
  conversation: ChatMsgBasic[];
} & Record<string, unknown>;

export type ChatMsgDebug = {
  inputs: ChatMsgDebugIO;
  outputs: ChatMsgDebugIO;
  step: string;
};

export type ChatMsgContentTypes =
  | ChatMessageContentTextual
  | ChatMessageContentStructured
  | ChatMessageContentLowCode
  | ChatMessageContentTyping
  | Record<string, unknown>;

export type ChatMsgBase<T extends ChatMsgContentTypes = Record<string, unknown>> = {
  content: T & { type: ChatMsgTypeEnum };
  messageId: string;
};

export type ChatMsgReq<T extends ChatMsgContentTypes = Record<string, unknown>> = {
  authorId: string;
  createdAt: DateTime;
  updatedAt: DateTime;
} & ChatMsgBase<T>;

export type ChatMsgRes<T extends ChatMsgContentTypes = Record<string, unknown>> = ChatMsgBase<T>;

export enum CompletionResponseTypeEnum {
  AI_DATA_PLATFORM_ERROR = 'AiDataPlatformError',
  AI_DATA_PLATFORM_FAILURE = 'AiDataPlatformFailure',
  AI_DATA_PLATFORM_RESULT = 'AiDataPlatformResult'
}

type CompletionResBase = {
  correlationId: string;
  requestId: string;
  responseId: string;
};

export type CompletionResError = CompletionResBase & {
  type: CompletionResponseTypeEnum.AI_DATA_PLATFORM_ERROR;
  error_message: string;
};

export type CompletionResFailure = CompletionResBase & {
  type: CompletionResponseTypeEnum.AI_DATA_PLATFORM_FAILURE;
  failure_message: string;
};

export type CompletionResResult = CompletionResBase & {
  type: CompletionResponseTypeEnum.AI_DATA_PLATFORM_RESULT;
  messages: ChatMsgRes[];
};

export type CompletionRes = CompletionResError | CompletionResFailure | CompletionResResult;

export type ChatMsgHistoryItem<T extends ChatMsgContentTypes = Record<string, unknown>> = {
  role: ChatRoleEnum;
} & ChatMsgReq<T>;

export type ChatMsgHistory = ChatMsgHistoryItem[];









export type ChatMsgBasic = {
  role: ChatRoleEnum;
  content: string;
};

export type ChatMsgBasicHistory = ChatMsgBasic[];